import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_8 = {
  key: 1,
  class: "col-sm-6"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "card card-body mb-0" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "form-group mb-2 col" }
const _hoisted_19 = { class: "col-auto p-0 text-end" }
const _hoisted_20 = { class: "col-sm-12" }
const _hoisted_21 = { class: "card card-body" }
const _hoisted_22 = { class: "overflow-auto" }
const _hoisted_23 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = { class: "text-capitalize-first" }
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = ["href"]
const _hoisted_30 = ["title"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["title"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "fa-solid fa-spinner fa-spin-pulse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.summary)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.walletBalance')) + ": ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.summary?.wallets)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.accountBalance')) + ": ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.summary?.accounts)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.correctionSum')) + ": ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.summary?.correction)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.diffSum')) + ": ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.summary?.diff)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.energyCheck && (_ctx.feeeIOData || _ctx.tronenergyData))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.tronenergyData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", null, [
                                _cache[5] || (_cache[5] = _createTextVNode(" TronEnergy balance: ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.tronenergyData?.value / 1000000) + " TRX", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.feeeIOData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", null, [
                                _cache[6] || (_cache[6] = _createTextVNode(" FeeeIO balance: ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.feeeIOData?.data?.trx_money) + " TRX", 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[7] || (_cache[7] = _createTextVNode(" FeeeIO top up address: ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.feeeIOData?.data?.recharge_address), 1),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createVNode(_component_copy_button, {
                                  value: _ctx.feeeIOData?.data?.recharge_address
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[9] || (_cache[9] = _createTextVNode(" FeeeIO only from: ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.feeeIOData?.data?.trx_address), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.address.tron'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.address) = $event))
                        }, null, 8, _hoisted_17), [
                          [_vModelText, _ctx.requestDTO.address]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("table", _hoisted_23, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1)),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.address.tron')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.owner')), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.account')), 1),
                        _cache[11] || (_cache[11] = _createElementVNode("th", { class: "text-capitalize-first" }, "TRX", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("th", { class: "text-capitalize-first" }, "USDT", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets.items, (wallet) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: wallet.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, _toDisplayString(wallet.id), 1),
                          _createElementVNode("td", null, [
                            (_ctx.walletsInfo[wallet.address] && !_ctx.walletsInfo[wallet.address]?.isActivated)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  title: _ctx.helper.trans('labels.wallet_not_activated'),
                                  class: "fa fa-warning text-warning me-2"
                                }, null, 8, _hoisted_27)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true),
                            (wallet.type === _ctx.WalletType.COLD)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  class: "me-2 fa-solid fa-temperature-low text-primary",
                                  title: _ctx.helper.trans('labels.cold_wallet')
                                }, null, 8, _hoisted_28)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(wallet.address), 1),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createVNode(_component_copy_button, {
                              value: wallet.address
                            }, null, 8, ["value"]),
                            _createElementVNode("a", {
                              href: `https://tronscan.org/#/address/${wallet.address}`,
                              class: "ms-2",
                              target: "_blank"
                            }, _cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "fa fa-external-link" }, null, -1)
                            ]), 8, _hoisted_29)
                          ]),
                          _createElementVNode("td", null, [
                            (wallet.accountOwner)
                              ? _withDirectives((_openBlock(), _createElementBlock("small", {
                                  key: 0,
                                  class: _normalizeClass([{'bg-secondary': wallet.accountOwner.type === 'store' ,'bg-danger': wallet.accountOwner.type === 'system', 'bg-primary': wallet.accountOwner.type === 'trader', 'bg-info': wallet.accountOwner.type === _ctx.UserRole.TRADER_TEAM_LEAD || wallet.accountOwner.type === _ctx.UserRole.REFERRAL}, "badge"]),
                                  title: _ctx.helper.trans(`account_owner.${wallet.accountOwner?.type}`)
                                }, [
                                  _createTextVNode(_toDisplayString(wallet.accountOwner?.name), 1)
                                ], 10, _hoisted_30)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (wallet.accountId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _withDirectives((_openBlock(), _createElementBlock("span", {
                                    title: wallet.accountId
                                  }, [
                                    _createTextVNode(_toDisplayString(wallet.accountId?.substring(0, 8)) + "...", 1)
                                  ], 8, _hoisted_32)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ]),
                                  _cache[16] || (_cache[16] = _createTextVNode()),
                                  _createVNode(_component_copy_button, {
                                    value: wallet.accountId
                                  }, null, 8, ["value"])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_33, "n/a"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.walletsInfo[wallet.address] ? _ctx.numberFormatter.formatNumber(_ctx.walletsInfo[wallet.address].trx) : 'n/a'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.walletsInfo[wallet.address] ? _ctx.numberFormatter.formatNumber(_ctx.walletsInfo[wallet.address].usdt) : 'n/a'), 1),
                          _createElementVNode("td", null, [
                            (_ctx.walletsInfo[wallet.address])
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.loadWalletBalance(wallet)), ["prevent"]),
                                  style: {"cursor":"pointer"},
                                  class: "fa-solid fa-rotate"
                                }, null, 8, _hoisted_34))
                              : (_openBlock(), _createElementBlock("i", _hoisted_35))
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.wallets.totalCount > _ctx.wallets.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadWallets()))
                        ],
                        "total-rows": _ctx.wallets.totalCount,
                        "per-page": _ctx.wallets.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}